// extracted by mini-css-extract-plugin
export default {"container":"translationsItem_container__X85gE","key":"translationsItem_key__7yedI","es":"translationsItem_es__8RTXV","other":"translationsItem_other__NtFRG"};